module.exports = __webpack_public_path__ + "img/log-out.dcb1332e.svg";